import { HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { ChannelService } from '../shared/channel.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
@Injectable()
export class LoginEventsService implements OnInit {

    private site: string;

    constructor(
        private bdbSessionStorageService: BdbSessionStrgService,
        private channelService: ChannelService
    ) { }

    ngOnInit() {
    }

    private loadSite() {
        this.site = this.bdbSessionStorageService.get(SessionStorageKeysEnum.SITE);
        console.log('Site session event: ' + this.site);
    }

    public getHeadersLoginEvent() {
        this.loadSite();
        const headerJson = this.getHeaderJson();
        const headers = new HttpHeaders(headerJson);
        return headers;
    }

    public getHeaderJson() {
        const headerJson = {
            'channel': this.channelService.getChannel(),
            'product': this.site,
            'aditional-Info': this.addAditionalInfoHeaders()
        };
        return headerJson;
    }

    /**
     *
     * @param headers
     */
    public addHeadersLoginEvent(headers: Headers) {
        this.loadSite();
        headers.append('channel', this.channelService.getChannel());
        headers.append('product', this.site);
        headers.append('aditional-Info', this.addAditionalInfoHeaders());
        return headers;
    }

    /**
     * Adiciona informacion adicional a la cabecera aditional-Info
     */
    private addAditionalInfoHeaders() {
        const info = 'private-ip=' + this.getPrivateIp() + ';';
        return info;
    }

    /**
     * retorna la ip privada almacenada en la session
     */
    private getPrivateIp() {
        return this.bdbSessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/login-events.service.ts